import { CATALOGUE_COLUMN_LABELS } from "./columnLabelsCatalogue";
import { CUSTOMER_COLUMN_LABELS } from "./columnLabelsCustomer";
import { MONEY_COLUMN_LABELS } from "./columnLabelsMoney";
import { TYPE_COLUMN_LABELS } from "./columnLabelsTypes";

// Plain-language names of the columns the audit log stores, shared by every entity. Keys are the
// backend's property names; an entity that gives one a different meaning overrides it in
// ENTITY_COLUMN_LABELS (columnLabelsEntity.ts). Anything missing falls back to a humanised name.
export const COLUMN_LABELS: Record<string, string> = {
  ...TYPE_COLUMN_LABELS,
  ...CATALOGUE_COLUMN_LABELS,
  ...MONEY_COLUMN_LABELS,
  ...CUSTOMER_COLUMN_LABELS,
  Deleted: "Fshirë",
  InsertDate: "Krijuar më",
  Name: "Emri",
  FirstName: "Emri",
  LastName: "Mbiemri",
  Email: "Email-i",
  PhoneNumber: "Telefoni",
  Description: "Përshkrimi",
  Price: "Çmimi",
  OneWayPrice: "Çmimi një drejtim",
  RoundTripPrice: "Çmimi vajtje-ardhje",
  RoundWayPrice: "Çmimi vajtje-ardhje",
  StationFrom: "Stacioni i nisjes",
  StationTo: "Stacioni i mbërritjes",
  DepartureTime: "Ora e nisjes",
  ArrivalTime: "Ora e mbërritjes",
  Duration: "Kohëzgjatja (minuta)",
  IsReservable: "I rezervueshëm",
  OperationalIntervalId: "Ditët e udhëtimit",
  LineId: "Linja",
  OldLineId: "Linja e mëparshme",
  TripId: "Orari",
  StationId: "Stacioni",
  ScheduleDepartureStationId: "Stacioni i nisjes",
  ScheduleArrivalStationId: "Stacioni i mbërritjes",
  CityId: "Qyteti",
  CountryId: "Shteti",
  OperatorId: "Operatori",
  CurrencyId: "Valuta",
  DefaultCurrencyId: "Valuta",
  AgeGroupId: "Grupmosha",
  PaymentMethodId: "Mënyra e pagesës",
  BusId: "Autobusi",
  StatusId: "Statusi",
  PaymentStatus: "Statusi i pagesës",
  PaymentDate: "Data e pagesës",
  JourneyDate: "Data e udhëtimit",
  JourneyTime: "Ora e udhëtimit",
  TicketsCount: "Numri i biletave",
  LineName: "Emri i linjës",
  OperatorName: "Emri i operatorit",
  StationName: "Emri i stacionit",
  CountryName: "Emri i shtetit",
  LocationName: "Emri",
  LogoUrl: "Logoja",
  PassportId: "Nr. i pasaportës",
  DateOfBirth: "Datëlindja",
  Updated: "I përditësuar",
  Fee: "Komisioni",
  EffectiveFrom: "Në fuqi nga",
  IsRevoked: "I hequr",
  OperatorCommisionFeePaymentType: "Aplikohet për",
  OperatorCommisionFeeValueType: "Lloji i vlerës",
  NationalFee: "Komisioni kombëtar",
  TravelBundleId: "Paketa",
  TravelBundleIncludeId: "Përfshirja",
  TravelBundlePrice: "Çmimi i paketës",
  FromDate: "Nga data",
  ToDate: "Deri më",
  MaxReservationCount: "Maks. rezervime",
  LocationId: "Qyteti",
  BlogId: "Blogu",
  PictureId: "Fotoja",
  IsCoverPicture: "Foto kryesore",
  DisplayOrder: "Renditja",
  Date: "Data",
  Type: "Lloji",
  PatternId: "Modeli",
  LocaleValue: "Vlera",
  LocaleKey: "Fusha",
  LocaleKeyGroup: "Për çfarë",
  LanguageId: "Gjuha",
  Amount: "Shuma",
  Direction: "Drejtimi",
  Reason: "Arsyeja",
  TicketId: "Bileta",
  JourneyReservationId: "Rezervimi",
  ConsumedByInvoiceId: "Fatura",
  ConsumedAtUtc: "Faturuar më",
  EventDateUtc: "Data e ngjarjes",
  RoleName: "Emri i rolit",
  Threshold: "Kufiri",
  Question: "Pyetja",
  Percentage: "Përqindja",
  PeriodFrom: "Periudha nga",
  PeriodTo: "Periudha deri",
  FromStationId: "Stacioni i nisjes",
  ToStationId: "Stacioni i mbërritjes",
  FromCityId: "Qyteti i nisjes",
  ToCityId: "Qyteti i mbërritjes",
  FromCountryId: "Shteti i nisjes",
  ToCountryId: "Shteti i mbërritjes",
  DepartureCityId: "Qyteti i nisjes",
  ArrivalCityId: "Qyteti i mbërritjes",
  UserRoleId: "Roli",
  PermissionRecordId: "Leja",
  PackageTemplateId: "Paketa",
  ToolName: "Emri i mjetit",
  IsEnabled: "Aktiv",
  IsActive: "Aktiv",
  Status: "Statusi",
  RewardAmount: "Shpërblimi",
  AmountRefunded: "Shuma e rimbursuar",
  IsRefundInCredits: "Në Gjirafa Money",
  Title: "Titulli",
  TripNoticeType: "Lloji i njoftimit",
  TripNoticePriority: "Përparësia"
};
